module.exports = __webpack_public_path__ + "img/alignment.b50d3141.svg";